<template>
  <div
    id="nav"
    class="navbar"
  >
    <!-- <div class="navbar-left">
      <span class="menuitem">
        {{ activeMenuItem }}
      </span>
    </div> -->

    <div class="navbar-left">
      <div class="search-container">
        <QSearch
          variant="secondary"
          size="l"
        />
      </div>
    </div>

    <div class="navbar-right">
      <!-- <button class="notification-btn" @click="handleNotifications">
        <v-icon name="bell" height="20" width="20" />
      </button> -->

      <!--  <div class="language-selector">
        <div class="language-dropdown" @click="toggleLanguageDropdown">
          <span class="language-text">{{ currentLanguage }}</span>
          <v-icon name="caret-down" height="16" width="16" class="dropdown-icon" />
        </div>
        <div v-if="showLanguageDropdown" class="language-dropdown-menu">
          <div class="language-option" @click="selectLanguage('RU')">RU</div>
          <div class="language-option" @click="selectLanguage('EN')">EN</div>
          <div class="language-option" @click="selectLanguage('JP')">JP</div>
        </div>
      </div> -->

      <div
        class="user-avatar"
        @mouseenter="showUserMenu"
        @mouseleave="hideUserMenu"
      >
        <v-icon
          name="user"
          height="25"
          width="25"
          stroke="var(--color-white)"
          action-color="var(--color-white)"
          @click.stop="toggleMenuVisible"
        />

        <div
          class="user-menu-container"
          @mouseenter="showUserMenu"
          @mouseleave="hideUserMenu"
        >
          <UserOverlay
            :is-open="isUserMenuOpen"
            @close="isUserMenuOpen = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, onUnmounted } from 'vue';
// import UsernameBadge from './UsernameBadge.vue';
import UserOverlay from '@/components/UI/overlay/UserOverlay.vue';
import AddBalance from '@/components/UI/modals/AddBalance.vue';
import QSearch from '@/components/UI/inputs/QSearch.vue';
// import { getUserState } from '@/firebase';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useModal } from 'vue-final-modal';
import i18n from '@/i18n';
import { AccessPermissionsEnum } from '@/router/constants';
import { useAuthService } from '@/modules/auth/auth.service';
// import { getUserById } from '@/services/merchant.service';
import { getMerchantCurrencySign } from '@/services/merchant.service';

const route = useRoute();
const store = useStore();
const { checkHasPermission } = useAuthService();
const currencySymbol = ref('');

// Новые состояния для редизайна
// const searchQuery = ref('');
const showLanguageDropdown = ref(false);
const currentLanguage = ref('RU');
const isUserMenuOpen = ref(false);

// const balance = ref(1790.35);
// const firstName = ref(' ');
// const lastName = ref(' ');
// const role = ref(' ');
// const user = ref({});

// const firstLast = computed(() => {
//   if (firstName?.value === '?') {
//     return '?';
//   }
//   return firstName?.value[0]?.toUpperCase() + lastName?.value[0]?.toUpperCase();
// });

// const fl = computed(() => {
//   if (firstName?.value === '?') {
//     return 'No data';
//   }
//   return `${firstName?.value} ${lastName?.value}`;
// });

const items = ref([
  // {
  //   title: 'nav.account',
  //   name: 'account',
  //   path: 'account',
  //   icon: 'user',
  //   accessPermissions: [AccessPermissionsEnum.CAN_READ_SUBSCRIPTION],
  // },
  {
    title: 'main.signout',
    name: 'login',
    path: 'login',
    addClick: true,
    icon: 'signout',
  },
]);

const menuItems = computed(() =>
  items.value?.filter((it) => !Object.hasOwn(it, 'accessPermissions') || checkHasPermission(it.accessPermissions)),
);

const activeMenuItem = computed(() => i18n.global.t(store.getters.get_menuitem || '_'));

const { open, close } = useModal({
  component: AddBalance,
  attrs: {
    onConfirm() {
      close();
    },
    onClose() {
      close();
    },
  },
  slots: {
    default: '<p>The content of the modal</p>',
  },
});

// const balanceFormat = Intl.NumberFormat('ru-RU', {
//   minimumFractionDigits: 2,
//   maximumFractionDigits: 2,
// });

const balanceModal = useModal({
  component: AddBalance,
  attrs: {
    onConfirm() {
      balanceModal.close();
    },
    onClose() {
      balanceModal.close();
    },
  },
  slots: {
    default: '<p>The content of the modal</p>',
  },
});

const isNotEmployee = computed(() => false);

// Новые методы для редизайна

const toggleLanguageDropdown = () => {
  showLanguageDropdown.value = !showLanguageDropdown.value;
};

const selectLanguage = (language) => {
  currentLanguage.value = language;
  showLanguageDropdown.value = false;
  // Здесь можно добавить логику смены языка
};

// const handleNotifications = () => {
//   // Логика обработки уведомлений
//   console.log('Notifications clicked');
// };

let hideTimeout = null;

const showUserMenu = () => {
  if (hideTimeout) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }
  isUserMenuOpen.value = true;
};

const hideUserMenu = () => {
  hideTimeout = setTimeout(() => {
    isUserMenuOpen.value = false;
  }, 200); // Задержка 200ms
};

const toggleMenuVisible = () => {
  isUserMenuOpen.value = !isUserMenuOpen.value;
};

// Обработчик клика вне overlay (оставляем для language dropdown)
const handleClickOutside = (event) => {
  const languageSelector = event.target.closest('.language-selector');

  if (!languageSelector && showLanguageDropdown.value) {
    showLanguageDropdown.value = false;
  }
};

onMounted(async () => {
  document.addEventListener('click', handleClickOutside);

  try {
    // const isAuth = await getUserState();
    // user.value = await getUserById(isAuth.uid);
    // if (isAuth !== null) {
    //   if (firstName.value) {
    //     firstName.value = user.value.firstName || user.value.firstName || '?';
    //     lastName.value = user.value.lastName || user.value.lastName || '';
    //   } else {
    //     firstName.value = user.value.firstName || user.value.firstName || '?';
    //     lastName.value = user.value.lastName || user.value.lastName || '';
    //   }
    //   firstName.value = user.value.firstName || user.value.firstName || '?';
    //   lastName.value = user.value.lastName || user.value.lastName || '';
    //   role.value = user.value.role || 'no data';
    // }
    if (route.meta.menuItems) store.commit('SET_MENUITEM', route.meta.menuItems);
  } catch (error) {
    console.log(error);
  }
  const currencyResult = await getMerchantCurrencySign();

  if (currencyResult && !currencyResult.error) {
    currencySymbol.value = currencyResult;
  } else if (currencyResult && currencyResult.error) {
    console.warn('Failed to get merchant currency, using fallback');
  }
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style lang="scss" scoped>
.navbar {
  background: #f5f5f5 !important;
  z-index: 10;
  width: 100%;
  height: 92px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  position: sticky;
  top: 0;
  left: 0;
}

.navbar-left {
  display: flex;
  align-items: center;
}

.navbar-center {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
}
.navbar-left {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-start;
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-container {
  width: 364px;
}

.notification-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  color: rgba(14, 14, 34, 0.4);
  transition: all 0.2s ease;

  &:hover {
    background: rgba(14, 14, 34, 0.05);
    color: rgba(14, 14, 34, 0.6);
  }
}

.language-selector {
  position: relative;
}

.language-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  height: 52px;
  width: 79px;
  background: #f7f7f7;
  border-radius: 16px;
  cursor: pointer;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease;

  &:hover {
    background: #f0f0f0;
  }
}

.language-text {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.2;
  color: rgba(14, 14, 34, 0.4);
}

.dropdown-icon {
  color: rgba(14, 14, 34, 0.4);
}

.language-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #f7f7f7;
  border-radius: 16px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.02);
  margin-top: 4px;
  overflow: hidden;
  z-index: 10;
}

.language-option {
  padding: 12px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  color: rgba(14, 14, 34, 0.8);
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(14, 14, 34, 0.05);
  }

  &:not(:last-child) {
    border-bottom: 1px solid #eaecee;
  }
}

.user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  background: #3b82f6;
  border-radius: 50%;
  cursor: pointer;
  color: var(--color-white);
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background: #2563eb;
  }
}

.menuitem {
  display: flex;
  align-items: center;
  padding: 12px 0px 12px 32px;
  color: $primary-color-dark;
  font-family: Montserrat;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  white-space: nowrap;
  overflow: hidden;
  gap: 30px;
}

.nav-top-balance {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  color: $primary-color-dark;
  cursor: pointer;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.user-menu-container {
  position: absolute;
  top: 110%;
  right: 0;
  z-index: 10;
}

.user-dropdown {
  display: none;
}
</style>
